import { Maybe } from 'graphql/jsutils/Maybe'
import { SeriesOptionsType } from 'highcharts'
import getCohortData from './getCohortData'
import { ChartColorOptions } from 'components/ReportElement'

interface GetBarChartDataProps {
  data: any
  toggles: 'Overall' | 'Subgroup' | 'Level' | 'Off'
  cohort: Maybe<string> | undefined
  subgroup: Maybe<string> | undefined
  pastResults: Maybe<boolean> | undefined
  parsedData: any
}

export default function getBarChartData({
  data = {},
  toggles,
  cohort,
  subgroup,
  pastResults,
  parsedData = {},
}: GetBarChartDataProps) {
  // let seriesData: SeriesOptionsType[] = []
  let seriesData: any[] = []
  if (data && toggles === 'Overall') {
    seriesData = seriesData.concat(data.current || [])
    //initially add past results to make sure colors stay consistent
    seriesData = seriesData.concat(data.past_results || [])

    const cohortData = getCohortData({
      cohortName: cohort || undefined,
      cohorts: data.cohorts,
      cohortSynonyms: parsedData.cohortSynonyms,
    }) as SeriesOptionsType | undefined

    if (cohortData) {
      seriesData = seriesData.concat([cohortData])
    } else {
      seriesData = seriesData.concat([{ name: 'None', data: [] }])
    }
    seriesData = seriesData.concat(data.comparative)
  }
  if (data && (toggles === 'Subgroup' || toggles === 'Level')) {
    const subgroupData = subgroup
      ? (data.segmentations || []).filter(
          (d: { name: string }) => d.name === subgroup
        )[0]
      : data.segmentations[0]
    if (subgroupData) {
      seriesData = subgroupData.series
    }
  }
  if (data && toggles === 'Off') {
    seriesData = data['data-points'] || data.series || []
  }
  seriesData = seriesData.map((d) => ({
    ...d,
    type: 'bar',
  })) as SeriesOptionsType[]
  return seriesData
}

export function getBarChartHeight(
  barType: 'stackedBarChart' | 'toggledBarChart',
  options: any
) {
  let length = 0
  if (barType === 'toggledBarChart') {
    length = options?.series?.data.length || 0
  } else {
    const series = (options?.series || [])[0]
    length = series && series.type === 'bar' ? series.data?.length || 0 : 0
  }
  const pointWidth = options?.plotOptions?.bar?.pointWidth || 20
  const padding = pointWidth / 2
  return (pointWidth + padding) * length + 50
}

export function getBarChartColors(dataLength: number) {
  const { colors } = ChartColorOptions(dataLength)
  let chartColors = [...colors]
  while (chartColors.length < dataLength) {
    chartColors = [...chartColors, ...colors]
  }
  return chartColors
}

type elementCohortType = { name: string; value: string }

export function getCohortToUse(
  cohort: string,
  elementCohorts: elementCohortType[],
  display = false
) {
  if (cohort === 'None') {
    return cohort
  }
  const found = elementCohorts.find((c) => c.value === cohort)
    ? cohort
    : elementCohorts[0] || {}
  return typeof found === 'string' ? found : display ? found.name : found.value
}

export function getSubgroupToUse(subgroup: string, elementSubgroups: string[]) {
  if (subgroup === 'None') {
    return subgroup
  }
  return elementSubgroups.includes(subgroup) ? subgroup : elementSubgroups[0]
}
